module.exports = __webpack_public_path__ + "img/glueck_im_unternehmen.8b1a5312.png";